import { render, staticRenderFns } from "./CardResultArticle.vue?vue&type=template&id=eb9f6c52&scoped=true"
import script from "./CardResultArticle.vue?vue&type=script&lang=js"
export * from "./CardResultArticle.vue?vue&type=script&lang=js"
import style0 from "./CardResultArticle.vue?vue&type=style&index=0&id=eb9f6c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9f6c52",
  null
  
)

export default component.exports